export class DocumentResponse {
  public success: boolean = false;
  public errorCode: string = '';
  public errorMessage: string = '';
  public documentId: number = 0;
  public userAttributeId: number = 0;
  public docBasePath: string = '';
  public docGUID: string = '';
  public docFullPath: string = '';
  public docExtType: string = '';
  public effectiveDTTM: Date = new Date();
  public effectiveDate;
  public expiryDate;
  public expiryDTTM: Date = new Date();
  public docNameWithExtension: string = '';
  public verificationStatus: string = '';
  public licenseState: string = '';
  public licenseNumber: string = '';
  public effectiveDTTMFlag: boolean = false;
  public expiryDTTMFlag: boolean = false;
  public licenseStateFlag: boolean = false;
  public licenseNumberFlag: boolean = false;
}
